module.exports = __webpack_public_path__ + "img/knet.03465964.svg";